import { Expose } from 'class-transformer';

export default class PreferredNurseFormError {
    practice_id: string[] = []
    nurse_id: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}